import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RequestOptions } from '@angular/http';
import { LocationStrategy, HashLocationStrategy, registerLocaleData } from '@angular/common';
import localeIT from '@angular/common/locales/it';
registerLocaleData(localeIT);


import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FullComponent } from './layouts/full/full.component';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { DemoMaterialModule } from './demo-material-module';

import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { FactoryModule } from './services/factory.service';

import { AuthService } from './services/auth.service';
import { DriverService } from './services/driver.service';
import { BaseService } from './services/base.service';
import { AdminService } from './services/admin.service';
import { ImpiantoService } from './services/impianto.service';
import { Broadcaster } from './services/broadcast.event';

import { ChangePasswordComponent } from './../app/change-password-component/change-password.component';
import { TwoFactorsAuthenticationComponent } from './../app/two-factors-authentication-component/two-factors-authentication.component';

import { SharedModule } from './shared/shared.module';
import { SpinnerComponent } from './shared/spinner.component';
import { LoaderService } from './services/loader.service';
import { ProfilePageComponent } from './profile-page/profile-page.component';
import { SharedService } from './services/shared.service';
import { ConfigService } from './services/app.service';
import { ListaStampantiDialogComponent } from './lista-stampanti-dialog/lista-stampanti-dialog.component';
import { OperatoreService } from './services/operatore.service';
import { WarningCasseOfflineDialogComponent } from './warning-casse-offline-dialog/warning-casse-offline-dialog.component';
import { EstrattoContoCreditiComponent } from './estratto-conto-crediti/estratto-conto-crediti.component';
import { CambioImpiantoCartaComponent } from './cambio-impianto-carta/cambio-impianto-carta.component';
import { AccordionDirective } from './shared/accordion';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
};

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppBlankComponent,
    AppSidebarComponent,
    ChangePasswordComponent,
    TwoFactorsAuthenticationComponent,
    ProfilePageComponent,
    ListaStampantiDialogComponent,
    WarningCasseOfflineDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    DemoMaterialModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    PerfectScrollbarModule,
    SharedModule,
    FactoryModule.forRoot(),
    ToastrModule.forRoot(),
    RouterModule.forRoot(AppRoutes)
  ],
  entryComponents: [
    ChangePasswordComponent,
    TwoFactorsAuthenticationComponent,
    ListaStampantiDialogComponent,
    WarningCasseOfflineDialogComponent
  ],
  providers: [
    AuthService,
    DriverService,
    BaseService,
    ImpiantoService,
    AdminService,
    Broadcaster,
    LoaderService,
    SharedService,
    ConfigService,
    OperatoreService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }, {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    { provide: LOCALE_ID, useValue: "it-IT" }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts